<template>
  <div
    class="address-tree-item col-block"
    :class="{
      'is-invalid': hasError === true
      }"
  >
    <label>
      {{attr.label}} {{required ? '*' : ''}}
    </label>
    <select
      ref="select"
      :name="name"
      v-model="model[name]"
      :disabled="disabled"
      @change="onChange"
    >
      <option value="" key="_" disabled>{{getPlaceholder}}</option>
      <option
        v-for="item in attr.items"
        :value="item[attr.idKey]"
        :key="item[attr.idKey]"
      >{{item[attr.nameKey]}}</option>
    </select>
    <span
      class="invalid error"
      v-if="error"
    >
        {{error}}
      </span>
  </div>
</template>

<script>
  // data-* attributes used for debug
  export default {
    name: 'address-tree-item',
    data () {
      return {
        error: null
      }
    },
    props: {
      onChangeValidation: {
        type: Boolean,
        default: false
      },
      formValidator: null,
      model: {
        type: Object,
        required: true
      },
      tabView: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: null,
        required: true
      },
      validateAlias: {
        type: String,
        default: null
      },
      required: {
        type: Boolean,
        default: false
      },
      modalVariableName: {
        type: String,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: null
      },
      onValidate: {
        type: Function,
        default: (obj) => obj
      },
      attr: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      getPlaceholder () {
        if (this.placeholder === null) {
          return this.$translate('Выберите один из вариантов')
        }
        return this.$translate(this.placeholder)
      },
      hasError () {
        if (this.error) {
          return true
        }
        return false
      }
    },
    created () {
      if (this.formValidator) {
        this.formValidator.subscribeInput(this)
      }
    },
    destroyed () {
      if (this.formValidator) {
        this.formValidator.unsubscribeInput(this)
      }
    },
    methods: {
      onChange () {
        if (this.onChangeValidation) {
          this.validate()
        }
      },
      isEmptyValue (val) {
        return !!(typeof val === "undefined" || val === null || val === '')
      },
      getElement () {
        return this.$refs.select
      },
      validate () {
        let msg = ''

        if (this.required && this.isEmptyValue(this.model[this.name])) {
          msg = 'Укажите значение'
        }

        return this.onValidate({
          error: msg,
          tabView: this.tabView,
          name: this.name,
          modalVariableName: this.modalVariableName,
          el: this.getElement(),
          model: this.model
        })
      }
    }
  }
</script>
